function formatProduct(data = {}) {
  const {
    id,
    hasVariants,
    images,
    storeSpecificData,
    stockOverride,
    averageRating,
    offers,
    name,
    brand,
    primaryCategory,
    variants,
    slug,
    metaData,
    seller,
    type,
    handlingDays,
  } = data

  const transformedOffers =
    offers && offers?.length > 0
      ? offers.map((offer = {}) => ({
          description: offer.description,
          offerId: offer.offerId,
          validTill: offer.validTill,
        }))
      : null

  const transformedPrimaryCategory = primaryCategory
    ? {
        name: primaryCategory.name,
        parentCategory: primaryCategory.parentCategory
          ? {
              name: primaryCategory.parentCategory.name,
              parentCategory: primaryCategory.parentCategory.parentCategory
                ? {
                    name: primaryCategory.parentCategory.parentCategory.name,
                  }
                : null,
            }
          : null,
      }
    : {}

  const transformedVariants = variants
    ? variants.map(variant => {
        if (variant) {
          return {
            id: variant.id,
            name: variant.name,
            fullName: variant.fullName,
            images: variant.images,
            offers: variant.offers,
            properties: variant.properties,
            storeSpecificData: variant.storeSpecificData,
          }
        }
        return null
      })
    : null

  return {
    id,
    hasVariants,
    images,
    storeSpecificData,
    stockOverride,
    slug,
    averageRating,
    offers: transformedOffers,
    name,
    brand: brand ? { name: brand.name } : null,
    primaryCategory: transformedPrimaryCategory,
    variants: transformedVariants,
    metaData,
    seller,
    type,
    handlingDays,
  }
}

export function formatProductPagination(data, name) {
  let filters = {}
  if (name !== 'home') {
    filters = data?.filters || {}
  }
  return {
    count: data?.count,
    limit: data?.limit,
    offset: data?.offset,
    filters,
    product: (data?.product || []).map(product => formatProduct(product)),
  }
}

function formatHomePageProductCollection(value = {}, name) {
  const collection = value?.collection
  const title = value?.title

  if (!collection) return { collection, title }

  return {
    collection: formatProductPagination(collection, name),
    title,
  }
}

export default formatHomePageProductCollection
